import { useEffect } from 'react';
import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { IExperienceFeatureSettings } from '@interfaces/event';

export const useHandleEventSettingsMsg = (
  lastJsonMessage: LastWebsocketJsonMessageType,
) => {
  const { setCurrentEvent } = useMytaverseEvent();

  useEffect(() => {
    if (!lastJsonMessage) {
      return;
    }

    const { action } = lastJsonMessage;

    if (action !== WebsocketAction.EventSettingsUpdated) {
      return;
    }

    const features = (lastJsonMessage as any).features as
      | IExperienceFeatureSettings
      | undefined;

    if (!features) {
      return;
    }

    setCurrentEvent((prev) => {
      if (!prev) {
        return prev;
      }

      return {
        ...prev,
        settings: {
          ...prev.settings,
          features,
        },
      };
    });
  }, [lastJsonMessage, setCurrentEvent]);
};
